/** Checkout form: plan, contact details, billing address and order summary. */
export default {
  title: "Checkout",
  intro:
    "Confirm your plan and billing details. Next you'll pick DSK Bank or PostBank on the payment page.",
  plan: {
    title: "Your plan",
    subtitle: "Change your plan here if you picked the wrong one.",
  },
  contact: {
    title: "Contact details",
    subtitle: "We send your receipt and order updates here.",
    creditsNote: "Your points are added to the account for this email.",
  },
  billing: {
    title: "Billing address",
    subtitle: "This address appears on your invoice and is verified by the bank.",
  },
  fields: {
    fullName: "Full name",
    email: "Email",
    phone: "Phone",
    company: "Company",
    addressLine1: "Address",
    addressLine2: "Apartment, floor, entrance",
    city: "City",
    postalCode: "Postal code",
    country: "Country",
    optional: "(optional)",
  },
  placeholders: {
    company: "Company name for the invoice",
    addressLine1: "Street and number",
    addressLine2: "Entrance B, Floor 1, Apartment 34",
  },
  errors: {
    acceptTerms: "Please confirm that you are at least 18 years old and accept the Terms of Use, Refund Policy and Delivery Policy.",
    fullNameRequired: "Please enter your full name.",
    emailRequired: "Please enter your email address.",
    emailInvalid: "Please enter a valid email address.",
    phoneRequired: "Please enter a phone number.",
    phoneInvalid: "Please enter a valid phone number.",
    addressLine1Required: "Please enter your street address.",
    cityRequired: "Please enter your city.",
    postalCodeRequired: "Please enter your postal code.",
    countryRequired: "Please select your country.",
    startFailed: "Could not start checkout.",
  },
  custom: {
    name: "Custom",
    yourPrice: "Your price",
    priceLabel: "Your price (€)",
    planName: "Media-Style Custom Plan",
    credits_one: "{{formatted}} point",
    credits_other: "{{formatted}} points",
    summary_one: "{{formatted}} point with {{level}} benefits.",
    summary_other: "{{formatted}} points with {{level}} benefits.",
    levelBenefits: "{{level}} benefits",
  },
  summary: {
    title: "Order summary",
    planName: "Media-Style {{plan}} Plan",
    billing: "{{credits}} · One-time payment",
    subtotal: "Subtotal",
    taxes: "Taxes",
    included: "Included",
    totalDueToday: "Total",
  },
  promo: {
    label: "Promo code",
    placeholder: "Enter code",
    apply: "Apply",
    applying: "Checking…",
    remove: "Remove",
    applied: "{{code}} applied",
    discount: "Discount ({{code}})",
    errors: {
      invalid: "This promo code is not valid.",
      not_started: "This promo code is not active yet.",
      expired: "This promo code has expired.",
      used_up: "This promo code has reached its usage limit.",
      min_order: "This promo code needs an order of at least {{amount}}.",
      failed: "Could not check the promo code. Please try again.",
    },
  },
  orderNow: "Order now · {{price}}",
  reviewOrder: "Review order",
  reviewNext: "You'll review your order before paying",
  review: {
    title: "Review your order",
    intro: "Check everything below before you pay. Nothing is charged until you complete the payment on the bank's page.",
    edit: "Edit",
    plan: "Plan",
    total: "Total",
    totalNote: "· one-time payment, all taxes included",
    contact: "Contact details",
    billing: "Billing address",
    notice:
      "By clicking “Order now” you place an order with an obligation to pay. You then choose your bank and pay on its secure page. Your receipt is emailed to you as soon as the payment is confirmed.",
  },
  opening: "Opening payment…",
  chooseBankNext: "You'll choose your bank next",
  acceptTerms:
    "I confirm that I am at least 18 years old and accept the <terms>Terms of Use</terms>, <refund>Refund Policy</refund> and <delivery>Delivery Policy</delivery>.",
  /** Display names only; the English name is what is sent to the bank. */
  countries: {
    Bulgaria: "Bulgaria",
    Austria: "Austria",
    Belgium: "Belgium",
    Croatia: "Croatia",
    Cyprus: "Cyprus",
    Czechia: "Czechia",
    Denmark: "Denmark",
    Estonia: "Estonia",
    Finland: "Finland",
    France: "France",
    Germany: "Germany",
    Greece: "Greece",
    Hungary: "Hungary",
    Ireland: "Ireland",
    Italy: "Italy",
    Latvia: "Latvia",
    Lithuania: "Lithuania",
    Luxembourg: "Luxembourg",
    Malta: "Malta",
    Netherlands: "Netherlands",
    Norway: "Norway",
    Poland: "Poland",
    Portugal: "Portugal",
    Romania: "Romania",
    Slovakia: "Slovakia",
    Slovenia: "Slovenia",
    Spain: "Spain",
    Sweden: "Sweden",
    Switzerland: "Switzerland",
    "United Kingdom": "United Kingdom",
    "United States": "United States",
    Canada: "Canada",
    Australia: "Australia",
  },
};
